<template>
    <b-modal :id="modalName" title="Paste From Excel: " scrollable hide-footer @shown="focusInput">
        <b-form @submit.stop.prevent="processPaste">
            <b-form-group id="textarea-group-paste-text-box">
                <b-form-textarea id="textarea" v-model="inputs.pasteContents" rows="3" max-rows="6"
                    ref="pasteTextBox"></b-form-textarea>
            </b-form-group>
            <b-form-row class="button-row">
                <b-col cols=2>
                    <b-button type="submit" variant="primary" class="btn-sm">
                        <span v-if="submitting">
                            <b-spinner small type="grow"></b-spinner>
                            Pasting...
                        </span>
                        <span v-else>Paste</span>
                    </b-button>
                </b-col>
            </b-form-row>
        </b-form>
    </b-modal>
</template>
<script>
export default {
    props: [],

    data() {
        return {
            modalName: 'modal-warehousing-stocktransfer-excel-paste',
            submitting: false,
            inputs: {
                pasteContents: '',
            }
        }
    },

    methods: {
        processPaste() {
            this.submitting = true
            let url = 'api/warehousing/stocktransfer/processpaste'
            axios.post(url, {
                pasteContents: this.inputs.pasteContents
            })
                .then((res) => {
                    if (res.data.status == 'success') {
                        this.showAlertBox('success', 'Content Pasted', 'Content pasted successfully!')
                        this.$emit('updateRowItems', res.data.rows)
                        this.closeModal(this.modalName)
                    } else {
                        this.showAlertBox('error', 'Invalid Content', 'Pasted contents not in CSV tabbed delimited format. Please try again!')
                    }

                    this.submitting = false
                }, () => {
                    this.has_error = true
                })
        },

        focusInput() {
            this.$refs.pasteTextBox.focus()
        }
    },

    mounted() {

    }
}
</script>
<style lang="scss">
.modal-content {
    .modal-footer {
        .footer-block {
            text-align: center;
        }
    }
}
</style>
